export * from './colors';
export * from './shades';
export * from './consts';
export * from './cssColor';
export * from './rgb2hex';
export * from './clamp';
export * from './hsl2rgb';
export * from './hsl2hsv';
export * from './hsv2rgb';
export * from './hsv2hex';
export * from './rgb2hsv';
export * from './hsv2hsl';
export * from './getColorFromString';
export * from './getColorFromRGBA';
export * from './getColorFromHSV';
export * from './getFullColorString';
export * from './updateSV';
export * from './updateH';
export * from './updateRGB';
export * from './getColorFromString';
export * from './updateA';
export * from './updateT';
export * from './correctRGB';
export * from './correctHSV';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/utilities/color/index.js
// module id = 688
// module chunks = 0